function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledVideosGalleryComponent } from "./videos-gallery-component.scss";
import VideoThumbnailItemComponent from "/components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component";
import YoutubeVideoModalComponent from "/components/core/youtube-video-modal/youtube-video-modal-component";
import { VIDEO_OPTS } from "constants/youtube-modal";
class VideosGalleryComponent extends PureComponent {
    onVideoThumbnailClick(activeVideoIndex) {
        this.setState({
            showVideo: true,
            activeVideoIndex
        });
    }
    onCloseVideoModal() {
        this.setState({
            showVideo: false
        });
    }
    getCurrentVideo() {
        const { videos } = this.props;
        const { activeVideoIndex } = this.state;
        return videos[activeVideoIndex];
    }
    renderVideoItem(video, index) {
        return /*#__PURE__*/ _jsx(VideoThumbnailItemComponent, _object_spread_props(_object_spread({
            index: index
        }, video), {
            onClick: this.onVideoThumbnailClick
        }), index);
    }
    render() {
        const { title, videos } = this.props;
        const { showVideo } = this.state;
        const activeVideo = this.getCurrentVideo();
        return /*#__PURE__*/ _jsxs(StyledVideosGalleryComponent, {
            className: "videos-gallery-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "videos-gallery-title",
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "videos-list-wrapper",
                    children: videos.map(this.renderVideoItem)
                }),
                showVideo && /*#__PURE__*/ _jsx(YoutubeVideoModalComponent, {
                    videoId: activeVideo.videoId,
                    footerText: activeVideo.videoFooterText,
                    minHeight: 546,
                    isOpen: true,
                    opts: VIDEO_OPTS,
                    onCloseModal: this.onCloseVideoModal
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            showVideo: false,
            activeVideoIndex: null
        };
        this.onVideoThumbnailClick = this.onVideoThumbnailClick.bind(this);
        this.onCloseVideoModal = this.onCloseVideoModal.bind(this);
        this.renderVideoItem = this.renderVideoItem.bind(this);
    }
}
export { VideosGalleryComponent as default };
